<!-- //
组件-动态环形图
@auth xuyd
@date 2024-05-03
//-->
<template>
  <PropsWrapper :widgetProps="widgetProps">
  </PropsWrapper>
</template>

<script>

export default {
  name: 'WidgetActiveRingForm',
  components: {},
  data() {
    return {
    }
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    viewProps() {
      return this.widgetProps.viewProps;
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
</style>
